module.exports = __webpack_public_path__ + "static/media/fon5_arh1.66bdb2a4.svg";